export default __webpack_public_path__ + "static/media/ic_mauritania.1d1f0899.svg";